import React, { Component } from "react";
import axios from "../../axios";
import Alert from "react-s-alert";
import FormDropdown from "../../components/FormDropdown";
import { status_aktif } from "../../constants/general";
import qs from "qs";
import DropdownView from "./DropdownView";
import { SERVER_API } from "../../constants/siteConfig";
import XLSX from 'xlsx'
import Dropzone from 'react-dropzone'


class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			mapel_id: "",
			question_type: "",
			option_count: "",
			file: [],
			dataMapel : [],
			isButtonLoading: false,
			isLoading: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeJumlah = this.handleChangeJumlah.bind(this);
		this.handleChangeMapel = this.handleChangeMapel.bind(this);
		this.exportFile = this.exportFile.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" || target.type === "radio"  ? target.checked : target.value;

		const name = target.name;

		const newState = {
			[name]: value
		}

		if (name === "question_type") {
			newState.option_count = ""
		}

		this.setState(newState);
	}

	handleChangeMapel(event) {
		const target = event.target;
		const value  = target.value;
		const name   = target.name;

		this.setState({
			[name] : value,
		})
	}

	handleChangeJumlah(event) {
		const target = event.target;
		const value = target.type === "checkbox" || target.type === "radio"  ? target.checked : target.value;

		const name = target.name;

		const newState = {
			[name]: value
		}

		if (name === "question_type") {
			newState.option_count = ""
		}

		this.setState(newState);
	}

	exportFile() {
		if (this.state.question_type === '') {
			Alert.error("Type soal wajib dipilih!");return false;
		}

		if (this.state.mapel_id === '') {
			Alert.error("Mapel wajib dipilih!");return false;
		}

		if (this.state.question_type !== 'essay' && this.state.option_count === '') {
			Alert.error("Jumlah opsi harus diisi!");return false;
		}

		if (this.state.question_type == 'single') {
			let op = ["mapel", "soal", "jmlOpsi"];

			for (var i = 1; i <= this.state.option_count; i++) {
				op.push(i);
			}

			op.push('jwbBenar');
			op.push('keterangan');

			let single = [op]

			single.push([this.state.mapel_id,"", this.state.option_count])
			const wb = XLSX.utils.book_new()
			const wsAll = XLSX.utils.aoa_to_sheet(single)
			XLSX.utils.book_append_sheet(wb, wsAll, this.state.question_type)
			XLSX.writeFile(wb, "Format Import Soal "+ this.state.question_type +".xlsx");
		}

		if (this.state.question_type == 'essay') {
			let op = ["mapel", "soal","keterangan"];
			let essay = [op]

			essay.push([this.state.mapel_id,""])
			const wb = XLSX.utils.book_new()
			const wsAll = XLSX.utils.aoa_to_sheet(essay)
			XLSX.utils.book_append_sheet(wb, wsAll, this.state.question_type)
			XLSX.writeFile(wb, "Format Import Soal "+ this.state.question_type +".xlsx");
		}

		if (this.state.question_type == 'match') {
			let op = ["mapel", "soal", "jmlOpsi"];
			for (var i = 1; i <= this.state.option_count; i++) {
				op.push(i);
			}

			for (var i = 1; i <= this.state.option_count; i++) {
				op.push("" + i + i);
			}

			op.push('keterangan');

			let match = [op]

			match.push([this.state.mapel_id,"", this.state.option_count])
			const wb = XLSX.utils.book_new()
			const wsAll = XLSX.utils.aoa_to_sheet(match)
			XLSX.utils.book_append_sheet(wb, wsAll, this.state.question_type)
			XLSX.writeFile(wb, "Format Import Soal "+ this.state.question_type +".xlsx");
		}

		if (this.state.question_type == 'multi') {
			let op = ["mapel", "soal", "jmlOpsi"];
			for (var i = 1; i <= this.state.option_count; i++) {
				op.push(i);
			}

			op.push('jwbBenar');
			op.push('keterangan');

			let multi = [op]

			multi.push([this.state.mapel_id,"", this.state.option_count])
			const wb = XLSX.utils.book_new()
			const wsAll = XLSX.utils.aoa_to_sheet(multi)
			XLSX.utils.book_append_sheet(wb, wsAll, this.state.question_type)
			XLSX.writeFile(wb, "Format Import Soal "+ this.state.question_type +".xlsx");
		}


	}

	loadDataMapel(){
		axios.post("/mapel")
			.then(response => {
				return response.data.data.map(item => ({
					key: item.mapel_id,
					value : item.mapel_nama
				}))
			})
			.then(result => {
				this.setState({
					dataMapel: result
				})
			})
			.catch(error => {
				console.log("Mapel Undefinded")
			})
	}

	handleDeleteFile(index) {

		const copiedStateFiles = [
			...this.state.file
		]

		copiedStateFiles.splice(index, 1)

		this.setState({
			file: copiedStateFiles
		})
	}

	onDrop(files) {
		const newState = this.state.file.concat(files)
		this.setState({
			file: newState
		});
	}

	handleSubmit() {
		let formData = new FormData();
		const config = {
			headers: { 'content-type': 'multipart/form-data' }
		}

		if ([]) {
			formData.append('file', this.state.file[0])
		}else{
			formData.append('file', '')
		}

		formData.append('mapel_id', this.state.mapel_id)
		formData.append('option_count', this.state.option_count)
		formData.append('question_type', this.state.question_type)
		formData.append("user_id", localStorage.SISMART_USER_ID)

		const url = "soal/import"

		this.setState({ isButtonLoading: true })

		axios.post(url, formData, config)
			.then(response => {
				const result = response.data;

				if (result.success) {
					Alert.success(result.message)
					this.props.history.replace("/soal")
				}
				else {
					if (Array.isArray(result.message)) {

						result.message.map(item => {
							Alert.error(item)
							return true
						})
					}
					else {
						Alert.error(result.message)
					}
					this.setState({ isButtonLoading: false })
				}
			})

			.catch(error => {
				console.log("ERROR", error)
				Alert.error("Gagal terhubung ke server!")
				this.setState({ isButtonLoading: false })
			})
	}

	componentDidMount() {
		this.loadDataMapel();

	}

	render() {
		return (
			<div className="col-sm-12">
				<div className="card" >
					<div className="card-header">{this.props.mode} Pertanyaan</div>
					<div className="card-block">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : (
							<div className="form-horizontal animated fadeIn">
								<div className="form-group row">
									<div className="col-md-12">
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Mata pelajaran
											</label>
											<div className="col-md-4">
												<FormDropdown
													items = {this.state.dataMapel}
													onChange = {this.handleChangeMapel}
													value={this.state.mapel_id.toString()}
													required=""
													placeholder={"Pilih Mapel"}
													name="mapel_id"
												/>
											</div>
										</div>
										<div className="form-group row">
											<label className="col-md-2 form-control-label">
												Type Soal
											</label>
											<div className="col-md-4">
												<FormDropdown
													onChange = {this.handleChange}
													value={this.state.question_type}
													placeholder={"Pilih Type Soal"}
													name="question_type"
													items={[
														{ key: "single", value: "Single Option" },
														{ key: "essay", value: "Essay" }
													]}
												/>
											</div>
										</div>
										{this.state.question_type === '' ? (
											""
										) : (

											this.state.question_type !== "essay"  ? (
												<div className="form-group row">
													<label className="col-md-2 form-control-label">
														Opsi Soal
													</label>
													<div className="col-md-4">
														<FormDropdown
															onChange={this.handleChangeJumlah}
															placeholder={" Jumlah Opsi Soal "}
															name="option_count"
															required
															items={[
																{ key: "3", value: "3" },
																{ key: "4", value: "4" },
																{ key: "5", value: "5" },
																{ key: "6", value: "6" }
															]}
															value={this.state.option_count}
														/>
													</div>
												</div>
											) : ""
										)}
										<div className="col-md-6">
											<button
												className="btn btn-primary pull-right"
												disabled={this.state.isButtonLoading && "disabled"}
												onClick={this.exportFile}>
												{this.state.isButtonLoading ? "Loading" : "Generate Excel Format"}
											</button>{" "}

										</div>
										<label className="col-md-12 form-control-label">
											<strong>*Tentukan soal mapel apa yg anda ingin import, Lalu generate excel format</strong><br/>
											<strong>*Pastikan file sesuai formatnya seperti yg anda generate</strong><br/>
										</label>
										<div className="form-group row">
											<label className="col-md-12 form-control-label">File Import</label>
											<div className="col-md-12">

												<Dropzone
													onDrop={this.onDrop.bind(this)}
													style={{
														width: "100%",
														height: "auto",
														border: "2px dashed #e9e9e9",
														padding: "20px 30px",
														color: "#888",
														cursor: "pointer",
														textAlign: "center",
														marginBottom: "15px"
													}}
												>
													Klik atau drop file disini untuk mengupload file
												</Dropzone>

												<ul>
													{
														this.state.file.map((item, index) =>
															<li key={"file" + index} style={{ marginBottom: "10px" }}>
																{item.name} {" "}
																<button
																	title="Hapus"
																	className="btn btn-sm btn-danger"
																	onClick={() => this.handleDeleteFile(index)}
																	type="button"
																>
																	<i className="fa fa-remove"></i>
																</button>
															</li>
														)
													}
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className="card-footer">


						<button
							type="button"
							className="btn btn-md btn-primary"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={this.handleSubmit}
						>
							{this.state.isButtonLoading ? "Loading" : "Import"}
						</button>{" "}
						<button
							type="button"
							className="btn btn-md btn-danger"
							disabled={this.state.isButtonLoading && "disabled"}
							onClick={() => this.props.history.goBack()}
						>
							Batal
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Soal/Import.js